import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, computed } from 'vue'
import GdMap from '@/components/Maps/GdMap.vue'

import { defineComponent } from 'vue'

const __default__ = defineComponent({
  name: 'SwitchLocaltionDialog',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  modelValue: {
    type: Boolean,
    required: true,
  },
  areaCode: {
    type: String,
    default: '110000',
  },
  lat: {
    type: Number,
    default: 0,
  },
  lng: {
    type: Number,
    default: 0,
  },
},
  emits: ["update:modelValue", "confirm"],
  setup(__props, { emit }: { emit: ({
  (e: 'update:modelValue', value: boolean): void
  (e: 'confirm', payload: { lat: number; lng: number }): void
}), expose: any, slots: any, attrs: any }) {

const props = __props




let location: { lat: number; lng: number } = {
  lat: 0,
  lng: 0,
}

const showDialog = computed({
  get: () => {
    return props.modelValue
  },
  set: (val: boolean) => {
    emit('update:modelValue', val)
  },
})
const handleChangeLocaltion = (payload: { lat: number; lng: number }) => {
  location = payload
}
const submit = () => {
  emit('confirm', { ...location })
  showDialog.value = false
}
const handleDialogClose = async () => {
  showDialog.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _unref(showDialog),
    "onUpdate:modelValue": [
      _cache[1] || (_cache[1] = ($event: any) => (_isRef(showDialog) ? (showDialog).value = $event : null)),
      handleDialogClose
    ],
    title: _ctx.$t('Operation.selectLocation') + ',修改定位请重新点击地图'
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (showDialog.value = false))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('Base.cancel')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: submit
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('Base.confirm')), 1)
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(GdMap, {
        lat: props.lat,
        city: props.areaCode,
        lng: props.lng,
        onUpdateLngLat: handleChangeLocaltion
      }, null, 8, ["lat", "city", "lng"])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})